// The chosen items lead a picker's list; both groups keep the order they had.
export function getSelectedItemsFirst<T>(items: T[], isSelected: (item: T) => boolean): T[] {
  const selectedItems: T[] = []
  const otherItems: T[] = []
  for(const item of items) {
    (isSelected(item) ? selectedItems : otherItems).push(item)
  }
  return [...selectedItems, ...otherItems]
}
